#import "./ContractFields.graphql"

query GetContract($id: ID!) {
  contract(id: $id) {
    ...ContractFields
  }
}
